"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HE3FusionPlant = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const MoonExpansion_1 = require("../../moon/MoonExpansion");
const TileType_1 = require("../../TileType");
const Resources_1 = require("../../Resources");
const CardRenderer_1 = require("../render/CardRenderer");
const CardRequirements_1 = require("../CardRequirements");
const Card_1 = require("../Card");
const Size_1 = require("../render/Size");
class HE3FusionPlant extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.HE3_FUSION_PLANT,
            cardType: CardType_1.CardType.AUTOMATED,
            tags: [Tags_1.Tags.ENERGY, Tags_1.Tags.ENERGY, Tags_1.Tags.MOON],
            cost: 12,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.miningRate(2)),
            metadata: {
                description: 'Requires Mining Rate of 2 or higher. ' +
                    'Increase your energy production 1 step for each mine tile on the Moon.',
                cardNumber: 'M48',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => pb.energy(1)).nbsp(Size_1.Size.SMALL).slash().nbsp(Size_1.Size.SMALL).moonMine().any;
                }),
            },
        });
    }
    ;
    play(player) {
        const count = MoonExpansion_1.MoonExpansion.tiles(player.game, TileType_1.TileType.MOON_MINE, { surfaceOnly: true }).length;
        player.addProduction(Resources_1.Resources.ENERGY, count, { log: true });
        return undefined;
    }
}
exports.HE3FusionPlant = HE3FusionPlant;
//# sourceMappingURL=HE3FusionPlant.js.map